import * as Sentry from "@sentry/react";
import config from "../../utils/config"
import { BrowserTracing } from "@sentry/tracing"

const { SENTRY_DSN_WEB } = config()

const sentryOptions: Sentry.BrowserOptions = {
  dsn: SENTRY_DSN_WEB,
  integrations: [new BrowserTracing()],

  tracesSampleRate: 1.0
}

export {
  Sentry,
  sentryOptions
}
